export function formatSeconds(seconds: number) {
  const totalRunningTimeInMinute = seconds / 60;
  const totalRunningTimeInHour = totalRunningTimeInMinute / 60;

  const hoursOfTotalRunningTime = Math.floor(totalRunningTimeInHour);
  const minutesOfTotalRunningTime = Math.floor(totalRunningTimeInMinute - hoursOfTotalRunningTime * 60);
  const secondsOfTotalRunningTime = seconds % 60;

  const formattedHours = String(hoursOfTotalRunningTime).padStart(2, '0');
  const formattedMinutes = String(minutesOfTotalRunningTime).padStart(2, '0');
  const formattedSeconds = String(secondsOfTotalRunningTime).padStart(2, '0');

  if (hoursOfTotalRunningTime > 0) return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;

  return `${formattedMinutes}:${formattedSeconds}`;
}
